module.exports = "/virtual-football-league/img/amblems/right/logos/REAL SOCIEDAD.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/REAL SOCIEDAD.png
// module id = 2223
// module chunks = 4